import { Component, Input, OnInit } from '@angular/core';
import { KPI } from '../../../@core/api';
import { NbDialogService, NbCardModule } from '@nebular/theme';
import { SheetDialogComponent } from '../sheet-dialog/sheet-dialog.component';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-next-asset-item',
    templateUrl: './next-asset-item.component.html',
    styleUrls: ['./next-asset-item.component.scss'],
    standalone: true,
    imports: [NbCardModule, TranslateModule]
})
export class NextAssetItemComponent implements OnInit {

  @Input() public asset: KPI.MappedAsset;

  constructor(
    private dialogService: NbDialogService,
  ) { }

  ngOnInit(): void {
  }

  public navigateToAsset(assetId: number) {
    this.dialogService.open(
      SheetDialogComponent,
      {
        autoFocus: false,
        context: { assetId }
      }
    );
  }

  public getThumbnailUrl(): string | null {
    if (!this.asset?.pictures || this.asset.pictures.length === 0) {
      return null;
    }
    const image = this.asset.pictures[0];
    if (!image?.thumbnail) {
      return null;
    }
    let thumbnail = image.thumbnail.trim();
    thumbnail = thumbnail.replace(/["']/g, '');
    return thumbnail || null;
  }

}
